module.exports = __webpack_public_path__ + "img/mult.19e70c68.svg";